export default "__VITE_ASSET__C41gyvZK__"